import React from "react";
import { personalInfo } from "../data";
import { Mail, Phone, MapPin, Code, Database, Cloud, Users } from "lucide-react";
import "./PageStyles.css";

const AboutPage = () => (
  <div className="page">
    <header className="page-header">
      <h1 className="section-title">About Me</h1>
      <p className="page-lead">Passionate developer crafting digital solutions that make a difference.</p>
    </header>
    <section className="section">
      <div className="container">
        <div className="about-content-enhanced">
          <div className="about-main">
            <div className="about-text">
              <p className="about-paragraph">
                I'm a passionate MERN Stack Developer based in {personalInfo.location}, specializing in
                building modern, scalable web applications. With expertise in both frontend and backend
                development, I create seamless digital experiences that solve real-world problems.
              </p>
              <p className="about-paragraph">
                Currently working at The Revolution Technologies, I've contributed to diverse projects
                spanning e-commerce, education, finance, and hospitality sectors. My approach combines
                clean code practices with user-centric design to deliver high-quality solutions that
                drive business growth and enhance user satisfaction.
              </p>
              <p className="about-paragraph">
                I'm constantly learning and adapting to new technologies, ensuring that the solutions I
                build are not only functional but also future-proof. Whether it's optimizing database
                queries, implementing secure authentication systems, or creating responsive user interfaces,
                I bring attention to detail and a commitment to excellence to every project.
              </p>
            </div>
          </div>

          <div className="about-highlights">
            <div className="highlight-card">
              <div className="highlight-icon">
                <Code size={32} />
              </div>
              <h3 className="highlight-title">Full-Stack Development</h3>
              <p className="highlight-text">
                Building end-to-end solutions from frontend interfaces to backend APIs and database design.
              </p>
            </div>
            <div className="highlight-card">
              <div className="highlight-icon">
                <Database size={32} />
              </div>
              <h3 className="highlight-title">Database Expertise</h3>
              <p className="highlight-text">
                Designing efficient data models and optimizing queries for MongoDB, MySQL, and AWS DynamoDB.
              </p>
            </div>
            <div className="highlight-card">
              <div className="highlight-icon">
                <Cloud size={32} />
              </div>
              <h3 className="highlight-title">Cloud Integration</h3>
              <p className="highlight-text">
                Deploying and managing applications on AWS, Vercel, and other cloud platforms.
              </p>
            </div>
            <div className="highlight-card">
              <div className="highlight-icon">
                <Users size={32} />
              </div>
              <h3 className="highlight-title">User-Centric Design</h3>
              <p className="highlight-text">
                Creating intuitive interfaces that prioritize user experience and accessibility.
              </p>
            </div>
          </div>

          <div className="about-contact-section">
            <h3 className="contact-section-title">Get in Touch</h3>
            <div className="about-contact">
              <a href={`mailto:${personalInfo.email}`} className="contact-item">
                <Mail size={20} />
                <span>{personalInfo.email}</span>
              </a>
              <a href={`tel:${personalInfo.phone}`} className="contact-item">
                <Phone size={20} />
                <span>{personalInfo.phone}</span>
              </a>
              <div className="contact-item">
                <MapPin size={20} />
                <span>{personalInfo.location}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
);

export default AboutPage;

